var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWash2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "wash-2_svg__nc-icon-wrapper",
    strokeLinecap: "square",
    strokeWidth: 2,
    fill: "none",
    stroke: "gray",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 8h44M2 2h44v44H2z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-color": "color-2",
    cx: 24,
    cy: 27,
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    d: "M30 28c-1.2 0-2.3-.5-3-1.4-.7.8-1.8 1.4-3 1.4s-2.3-.5-3-1.4c-.7.8-1.8 1.4-3 1.4-.7 0-1.4-.2-2-.5.2 4.2 3.7 7.5 8 7.5s7.7-3.3 8-7.5c-.6.3-1.3.5-2 .5z"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHRpdGxlPndhc2ggMjwvdGl0bGU+PGcgY2xhc3M9Im5jLWljb24td3JhcHBlciIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgc3Ryb2tlLWxpbmVqb2luPSJtaXRlciIgc3Ryb2tlLXdpZHRoPSIyIiBmaWxsPSIjODA4MDgwIiBzdHJva2U9IiM4MDgwODAiPjxsaW5lIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzgwODA4MCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiB4MT0iMiIgeTE9IjgiIHgyPSI0NiIgeTI9IjgiLz4gPHJlY3QgeD0iMiIgeT0iMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjODA4MDgwIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHdpZHRoPSI0NCIgaGVpZ2h0PSI0NCIvPiA8Y2lyY2xlIGRhdGEtY29sb3I9ImNvbG9yLTIiIGZpbGw9Im5vbmUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgY3g9IjI0IiBjeT0iMjciIHI9IjE0Ii8+IDxwYXRoIGRhdGEtY29sb3I9ImNvbG9yLTIiIGZpbGw9Im5vbmUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTMwLDI4IGMtMS4yLDAtMi4zLTAuNS0zLTEuNGMtMC43LDAuOC0xLjgsMS40LTMsMS40Yy0xLjIsMC0yLjMtMC41LTMtMS40Yy0wLjcsMC44LTEuOCwxLjQtMywxLjRjLTAuNywwLTEuNC0wLjItMi0wLjUgYzAuMiw0LjIsMy43LDcuNSw4LDcuNXM3LjctMy4zLDgtNy41QzMxLjQsMjcuOCwzMC43LDI4LDMwLDI4eiIvPjwvZz48L3N2Zz4=";
export { SvgWash2 as ReactComponent };